import React from 'react';
import img1 from '../../Media/pepid-logo-color-mark-new.png'
import img2 from '../../Media/book-monitor.png'

const Section5 = () => {
    return (
        <div className='my-10 md:w-8/12 w-10/12 mx-auto text-center mb-20'>
            <div className='flex justify-center'>
                <img src={img1} alt="" />
            </div>
            <h3 className='text-4xl font-bold text-primary-600 '>This is Our Legacy.</h3>
            <p className='my-5'>As a training physician, Dr. Rosenbloom’s lab coat pockets overflowed with his handwritten, detailed medical and drug reference notes he realized it was invaluable in making diagnostic and therapeutic decisions. When the first personal digital assistants were released, Dr. Rosenbloom copied all of his notes into his handheld computer’s phone book.</p>
            <div className='flex justify-center my-5'>
                <img src={img2} alt="" />
            </div>
            <h3 className='text-4xl font-bold text-primary-600 '>To Every Modern Device</h3>
            <p className='my-5'>Colleagues encouraged Dr. Rosenbloom to expand his electronic notes into a portable, comprehensive medical and drug resource for more widespread use. As a result, in 1994, Dr. Rosenbloom developed the first version of PEPID with an advisory board of more than 35 board-certified physicians and pharmacologists.</p>
            <h2 className='text-4xl font-bold text-primary-600 '>Where does PEPID content come from?</h2>
            <p className='text-xl'>Trusted Content Partners. Frequent Updates. Peer-Reviewed.</p>
            <button className='text-2xl font-bold text-white bg-primary-500 hover:bg-primary-600 px-6 py-2 rounded-full my-5'>FIND OUT</button>
        </div>
    );
};

export default Section5;